<div class="main-holder">
  <aku-vertical-menu></aku-vertical-menu>
  <router-outlet></router-outlet>
</div>
